// extracted by mini-css-extract-plugin
module.exports = {"main-menu":"styles_main-menu__1QUyd","menu-item":"styles_menu-item__1oA00"};